import React from 'react';
import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  Paper,
  Typography
} from '@mui/material';

const ROW_HEIGHT = 56;

export function FTableCell(props) {
  return (
    <MuiTableCell
      {...props}
      sx={{
        border: 0,
        height: ROW_HEIGHT,
        minHeight: ROW_HEIGHT,
        paddingY: 0,
        verticalAlign: 'middle',

        '& > *': {
          maxHeight: 36,
          display: 'inline-flex',
          alignItems: 'center'
        },

        ...(props.sx || {})
      }}
    />
  );
}

export function FTable({
  title,
  columns = [],
  rows = [],
  emptyMessage = 'No data found',
  renderRow,
  containerSx = {},
  tableSx = {}
}) {
  return (
    <MuiTableContainer
      component={Paper}
      elevation={0}
      sx={{
        padding: 3,
        width: '100%',

        /*
         * The entire table container scrolls:
         * title + header + rows.
         */
        maxHeight: 'calc(100vh - 50px)',

        overflow: 'auto',

        scrollbarWidth: 'thin',

        '&::-webkit-scrollbar': {
          width: 6,
          height: 6
        },

        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)'
        },

        ...containerSx
      }}>
      {/* Title scrolls with the table */}
      {title && (
        <Typography
          variant="h4"
          sx={{
            margin: 2,
            fontWeight: 500
          }}>
          {title}
        </Typography>
      )}

      <MuiTable
        size="small"
        sx={{
          tableLayout: 'auto',
          ...tableSx
        }}>
        {/* Header scrolls with the table */}
        <MuiTableHead>
          <MuiTableRow sx={{ height: ROW_HEIGHT }}>
            {columns.map((column, index) => (
              <FTableCell
                key={index}
                sx={{
                  fontWeight: 600,
                  ...(column.width && {
                    width: column.width
                  })
                }}>
                {column.label}
              </FTableCell>
            ))}
          </MuiTableRow>
        </MuiTableHead>

        <MuiTableBody>
          {!rows || rows.length === 0 ? (
            <MuiTableRow sx={{ height: ROW_HEIGHT }}>
              <FTableCell colSpan={columns.length}>{emptyMessage}</FTableCell>
            </MuiTableRow>
          ) : (
            rows.map((row, index) => (
              <MuiTableRow
                key={row.id || index}
                sx={{
                  height: ROW_HEIGHT,

                  '&:nth-of-type(odd)': {
                    backgroundColor: 'rgb(236 236 236)'
                  }
                }}>
                {renderRow(row, index)}
              </MuiTableRow>
            ))
          )}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
}
